(function (corpOne) {
    /**
     * Shows a system message to the user via the ".kn-system-messages" element.
     * @param {string} message The system message.
     * @param {string} type Either "info", "warning", or "error".
     * @param {bool} logToConsole Instructs to also log to console.
    */
    corpOne.showMessage = function (message, type, logToConsole) {
        var messageElement = document.querySelector(".mc-system-messages");

        if (message && type) {
            if (type === "info") {
                messageElement.appendChild(corpOne.buildMessageMarkup(message, "light-blue lighten-5"));

                if (logToConsole) {
                    console.info(message);
                }
            } else if (type === "warning") {
                messageElement.appendChild(corpOne.buildMessageMarkup(message, "yellow lighten-4"));

                if (logToConsole) {
                    console.warn(message);
                }
            } else if (type === "error") {
                messageElement.appendChild(corpOne.buildMessageMarkup(message, "deep-orange lighten-2"));

                if (logToConsole) {
                    console.error(message);
                }
            }
        }
    };

    /**
     * Builds an HTML element of a system message.
     * @param {string} message The system message.
     * @param {string} cssClasses The CSS class selectors.
     * @returns {HTMLElement} The <p> element.
     */
    corpOne.buildMessageMarkup = function (message, cssClasses) {
        var paragraph = document.createElement("p");
        paragraph.classList = "mc-user-message " + cssClasses;
        paragraph.innerText = message;
        var div = document.createElement("div");
        div.classList = "col xl5 l9 m12 s12";
        div.appendChild(paragraph);
        var section = document.createElement("section");
        section.classList = "row section";
        section.appendChild(div);

        return section;
    };

}(window.corpOne = window.corpOne || {}));